"use strict";
exports.__esModule = true;
var mapCreate = function (id) {
    var element = document.getElementById(id);
    if (!element)
        return null;
    if (typeof google === 'undefined')
        return;
    var map = new google.maps.Map(document.getElementById(id), {
        disableDefaultUI: true,
        zoom: 14,
        maxZoom: 18,
        gestureHandling: 'greedy',
        clickableIcons: false
    });
    return map;
};
exports.mapCreate = mapCreate;
var mapStreetViewCreate = function (id) {
    var element = document.getElementById(id);
    if (!element)
        return null;
    if (typeof google === 'undefined')
        return;
    return new google.maps.StreetViewPanorama(document.getElementById(id));
};
exports.mapStreetViewCreate = mapStreetViewCreate;
var mapStreetViewPosition = function (map, center) {
    if (typeof google === 'undefined')
        return;
    map.setPosition(center);
};
exports.mapStreetViewPosition = mapStreetViewPosition;
var mapCenter = function (map, center) {
    if (typeof google === 'undefined')
        return;
    map.panTo(center);
};
exports.mapCenter = mapCenter;
var mapZoom = function (map, zoom) {
    if (typeof google === 'undefined')
        return;
    if (zoom >= 0)
        map.setZoom(zoom);
};
exports.mapZoom = mapZoom;
var mapListen = function (map, eventName, callback) {
    if (typeof google === 'undefined')
        return;
    map.addListener(eventName, callback);
};
exports.mapListen = mapListen;
var mapGetCenter = function (map) {
    if (typeof google === 'undefined')
        return;
    var center = map.getCenter();
    return {
        lat: center.lat(),
        lng: center.lng()
    };
};
exports.mapGetCenter = mapGetCenter;
var mapGetZoom = function (map) {
    if (typeof google === 'undefined')
        return;
    return map.getZoom();
};
exports.mapGetZoom = mapGetZoom;
var mapRemoveInfowindow = function (it) {
    if (typeof google === 'undefined')
        return;
    if (it.close) {
        var infoWindow = it;
        infoWindow.close();
    }
};
exports.mapRemoveInfowindow = mapRemoveInfowindow;
var mapRemoveMarker = function (it) {
    if (typeof google === 'undefined')
        return;
    if (it.setMap) {
        var marker = it;
        marker.setMap(null);
    }
};
exports.mapRemoveMarker = mapRemoveMarker;
var mapRemoveRoute = function (it) {
    if (typeof google === 'undefined')
        return;
    if (it.setMap) {
        var route = it;
        route.setMap(null);
    }
};
exports.mapRemoveRoute = mapRemoveRoute;
var mapAddObject = function (map, it) {
    if (typeof google === 'undefined')
        return;
    if (it.close) {
        var infoWindow = it;
        infoWindow.open(map);
        return;
    }
    if (it.onRemove) {
        var faMarker = it;
        faMarker.onRemove();
    }
    var setMapObject = it;
    setMapObject.setMap(map);
};
exports.mapAddObject = mapAddObject;
